import http from './http'

export const generateQuestContent = (payload) => {
    let baseUrl = process.env.REACT_APP_QUESTION_ANSWER_AI_URL

    return http({
        method: 'POST',
        data: payload,
        url: `${baseUrl}?service=treasure-hunt`
    })
}